module.exports = function () {
    if ($('.location-directory').length === 0) {
        return;
    }

    var loadMap = function ($placeholder, location) {
        var mapOptions = {
            zoom: 13,
            key: window.ICFGoogleMapsKey,
            center: location,
            size: '238x280',
            markers: location
        };

        var mapOptionsQuery = Object.keys(mapOptions).filter(function (key) {
            return mapOptions.hasOwnProperty(key);
        }).map(function (key) {
            return key + '=' + encodeURIComponent(mapOptions[key].toString());
        }).join('&');

        var $mapItem = $('<img style="width: 100%; height: auto; border: none;" src="https://maps.googleapis.com/maps/api/staticmap?' + mapOptionsQuery + '"/>');
        $placeholder.parent().append($mapItem);

        $mapItem[0].onload = function() {
            $placeholder.remove();
        };
    };

    $('.location-directory__location-link').click(function () {
        $(this).closest('.location-directory__container').find('.location-directory__tab-content-active').removeClass('location-directory__tab-content-active')
        $(this).closest('.location-directory__tab-content').addClass('location-directory__tab-content-active');
        
        var $clickedLocation = $(this).parents('.location-directory__location').first();

        $clickedLocation.find('[data-location]').each(function () {
            var $container = $(this);
            var $placeholder = $container.find('.location-directory__location-details-map-image-placeholder');
            if ($placeholder.length) {
                loadMap($placeholder, $container.data('location'));
            }
        });
    });

    $('.location-directory__location-link').modaal({ custom_class: "location-directory__detail-modal" });

    var id = window.location.hash.substring(1);

    if (id.length) {                
        var $locationLink = $('[href="#' + id + '"]').first();       

        if ($locationLink.length) {            
            var $directoryTabs = $locationLink.closest('.location-directory__container').find('.location-directory__tabs').first();
            $directoryTabs.find('.location-directory__tab-active').removeClass('location-directory__tab-active');            
            var region = $locationLink.closest('.location-directory__tab-content').data('id');            
            $directoryTabs.find('[data-reference="' + region + '"]').addClass('location-directory__tab-active');
            $locationLink.click();
        }        

        history.replaceState("", document.title, window.location.pathname + window.location.search);
    }

    $('.location-directory__tab').click(function () {
        $('.location-directory__tab-active').removeClass('location-directory__tab-active');        

        $(this).addClass('location-directory__tab-active');

        var reference = $(this).data('reference');
        var $referencedTab = $('[data-id="' + reference + '"]');

        $('.location-directory__tab-content-active').removeClass('location-directory__tab-content-active');
        $referencedTab.addClass('location-directory__tab-content-active');
    });   
};